// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".request-info__content[data-v-52c50a4e]{display:grid;justify-content:center;justify-items:center;margin:5.5rem 0}@media only screen and (max-width:20em){.request-info__content[data-v-52c50a4e]{margin:3rem 0}}.request-info__icon[data-v-52c50a4e]{font-size:2.5rem}.request-info__text[data-v-52c50a4e]{font-size:1.56rem;line-height:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
